module.exports = __webpack_public_path__ + "static/media/variants-choice1.11b1926e.png";